import { formatRFC3339 } from 'date-fns'

export const isDate = (date: unknown) => {
  return date instanceof Date && !isNaN(date.valueOf())
}

const MSK_TZ = 'Europe/Moscow'

type DateParts = { year: number; month: number; day: number }

function getDateParts(date: Date, timeZone: string): DateParts {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date)

  const get = (type: string) =>
    Number(parts.find((p) => p.type === type)!.value)

  return { year: get('year'), month: get('month'), day: get('day') }
}

export function isNextCalendarDay(
  dateStr: string,
  timeZone: string = MSK_TZ,
  now: Date = new Date(),
): boolean {
  const a = getDateParts(new Date(dateStr), timeZone)
  const b = getDateParts(now, timeZone)

  return a.year !== b.year || a.month !== b.month || a.day !== b.day
}

export const getCurrentISODateWithTimeZone = () => formatRFC3339(new Date())
